export const riderDetailFields = [
    {
        label: "CONTACT NUMBER",
        key: "phoneNumber",
        type: "phone",
        formatter: (value, record) => `+91 ${value || "N/A"}`
    },
    {
        label: "EMAIL",
        key: "email",
        type: "text",
        formatter: (value) => value || "N/A"
    },
    {
        label: "EMERGENCY CONTACT",
        key: "emergencyContact",
        type: "phone",
        formatter: (value) => `+91 ${value || "N/A"}`
    },
    {
        label: "BLOOD GROUP",
        key: "bloodGroup",
        type: "text",
        formatter: (value) => value || "N/A"
    }
];

export const modalStyles = {
    modal: {
        borderRadius: '12px',
        width: '572px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
    },
    header: {
        fontSize: '22px',
        fontWeight: '700',
        color: '#919191',
        lineHeight: '100%',
        height: '27px',
        marginBottom: '20px'
    },
    fieldContainer: {
        marginBottom: '16px',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(50% - 8px)',
        minWidth: '200px'
    },
    fieldLabel: {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '125%',
        letterSpacing: "0.25%",
        textTransform: 'uppercase',
        color: '#606060',
        textTransform: 'uppercase',
        marginBottom: '4px',
        display: 'block'
    },
    fieldValue: {
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '125%',
        letterSpacing: '125%',
        color: '#060606',
        height: '20px',
    },
    riderInfo: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
    },
    avatar: {
        marginRight: '12px'
    },
    riderName: {
        fontSize: '16px',
        fontWeight: '500',
        color: '#000',
        margin: 0,
        height: '19px',
    },
    userName: {
        fontSize: '14px',
        color: '#606060',
        margin: 0,
        fontWeight: '400',
        fontStyle: 'italic'
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '24px'
    },
    okButton: {
        backgroundColor: '#6528D8',
        borderColor: '#6528D8',
        borderRadius: '99px',
        width: '100%',
        height: '40px',
        padding: '0 12px',
    },
    okButtonText: {
        fontSize: '20px',
        fontWeight: '600',
        lineHeight: '100%',
        height: '24px'
    }
};